/**
 *  Add querystring parameters to url
 * @param url The url
 * @param params  The params
 * @returns  The updated url
 */
export function addQueryStringParams(url = '', params: Record<string, string>): string {
  let separator = url.indexOf('?') > -1 ? '&' : '?';
  let result = url.trim();
  const keys = Object.keys(params);
  for (let i = 0; i < keys.length; i += 1) {
    const k = keys[i];
    if (params[k] && params[k].length > 0) {
      result += `${separator + k}=${encodeURIComponent(params[k])}`;
      if (separator === '?') {
        separator = '&';
      }
    }
  }
  return result;
}

/*
 Place holder for other function
*/
export function other() {
  return false;
}
